/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsCreate } from "../../funcs/accountsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.PostApiWorkspaceServiceV1AccountsRequestBody$inboundSchema,
};

export const tool$accountsCreate: ToolDefinition<typeof args> = {
  name: "accounts_create",
  description: `Create a new account

Creates a new user account with initial workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
